import "/Users/caldis/Code/react-zmage/packages/core/src/components/Image/Image.module.less?css";
export default {"imageLayer":"imageLayer__yjPf3","zooming":"zooming__3mMU7","invalidate":"invalidate__MJYkk"};